import {Localizer, LocalizerStatic} from "@k/global/Localizer";

export class LocalizerVue extends Localizer {

    private static i18n:any = null;
    private static surroundWithSquareBrackets = s=>"["+s+"]";

    public translate = (key: string, fallback?: string)=>{
        if(LocalizerVue.i18n === null) {
            console.warn("localizer not initialized");
            return key;
        }
        return LocalizerVue.i18n.t(key);
    }


    static setI18nInstance(i18n) {
        LocalizerVue.i18n = i18n;

    }
}
